"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numOfCustomCoursesAvatars = void 0;
/* eslint-disable import/prefer-default-export */
var customCoursesApi_1 = require("./customCoursesApi");
Object.defineProperty(exports, "numOfCustomCoursesAvatars", { enumerable: true, get: function () { return customCoursesApi_1.numOfCustomCoursesAvatars; } });
